import React, { Component } from 'react';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import Button from 'src/components/html-elements/button';
import { Grid, Hidden } from '@material-ui/core';
import Icon from 'src/components/icon';
import './input-dropzone.scss';

const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

class InputDropzone extends Component {

    constructor(props) {
        super(props);
        this.state = {
            previewSrc: props.previewsrc || '',
            errorMessage: '',
        };
    }

    handleChange = (e) => {
        const {
            input: { onChange = () => { } },
            // maxSize = 2097152,
        } = this.props;

        let file;
        if (Array.isArray(e) && e.length === 0) {
            return;
        }
        if (Array.isArray(e) && e.length > 0) {
            [file] = e;
        } else {
            [file] = e.target.files;
        }

        // if (file.size > maxSize) {
        //     this.setState({ errorMessage: `O arquivo é muito grande. O tamanho máximo permitido é ${maxSize / 1024 / 1024}mb` });
        //     return;
        // }

        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({ previewSrc: reader.result });
        };

        if (file && validImageTypes.indexOf(file.type) !== -1) {
            reader.readAsDataURL(file);
        } else {
            this.setState({ previewSrc: '' });
        }
        onChange([file]);
    };

    render() {
        const {
            input,
            meta,
            label,
            style,
            imageIcon = null,
            multiple = false,
            onRemove = () => { },
            ...rest
        } = this.props;

        const files = input.value;
        const { previewSrc, errorMessage } = this.state;

        return (
            <Grid className="DropzoneWrapper" container style={style}>
                <Dropzone
                    className={classnames('InputDropzone', {
                        withFiles: files.length,
                    })}
                    onDrop={this.handleChange}
                    onChange={this.handleChange}
                    multiple={multiple}
                    {...rest}
                >
                    <Grid container>
                        {imageIcon && !files.length && (
                            <div className="image-icon">
                                <img src={imageIcon} alt="ImageIcon" />
                            </div>
                        )}
                        {label && !files.length && (
                            <Grid item xs={12}>
                                <div>
                                    <p className="label">{label}</p>
                                    <p>ou</p>
                                </div>
                            </Grid>
                        )}
                        <Grid item justify="center" xs={12}>
                            {!files.length && (
                                <Button className="primary">
                                    Clique aqui para adicionar
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={12} style={{ padding: '16px', textAlign: 'center' }}>
                            {((meta.touched && meta.error) || errorMessage) && <span className="error">{meta.error || errorMessage}</span>}
                        </Grid>
                    </Grid>
                </Dropzone>

                {files && files.length && (
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'flex-start',
                            }}
                        >
                            <Icon
                                code="trash"
                                color="#7740f9"
                                size={18}
                                onClick={onRemove}
                            />
                        </Grid>
                        {(previewSrc || imageIcon) && (
                            <Grid
                                item
                                sm={12}
                                md={12}
                                className="preview-wrapper"
                            >
                                <img
                                    className="preview"
                                    src={previewSrc || imageIcon}
                                    alt="Preview"
                                />
                                <Hidden smDown>
                                    <div className="filename">
                                        {files[0].name}
                                    </div>
                                </Hidden>
                            </Grid>
                        )}
                    </Grid>
                )}
            </Grid>
        );
    }

}

export default InputDropzone;
